import { IStateMallPharmacy } from '../../entity/StateEntity';
import {
  MALL_PHARMACY_STATUS_RELOAD,
  MALL_PHARMACY_STATUS_SUCCESS,
  MALL_PHARMACY_STATUS_REQUEST,
  MALL_PHARMACY_STATUS_FAILURE,
} from 'src/constants/ActionTypes';

const initialState: IStateMallPharmacy = {
  reload: true,
  isFetching: false,
  type: MALL_PHARMACY_STATUS_RELOAD,
  pharmacyList: [],
};

export const mallPharmacyState = (state: IStateMallPharmacy = initialState, action: IStateMallPharmacy): IStateMallPharmacy => {
  switch (action.type) {
    case MALL_PHARMACY_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        pharmacyList: action.pharmacyList,
      });

    case MALL_PHARMACY_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        pharmacyList: [],
      });

    case MALL_PHARMACY_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        pharmacyList: [],
      });

    case MALL_PHARMACY_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        pharmacyList: [],
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/mallPharmacyState.ts